import { InterviewLanguageConfig } from '@/types/pulse';

import en from '@/messages/en.json';
import es from '@/messages/es.json';
import fr from '@/messages/fr.json';
import pt from '@/messages/pt.json';
import hi from '@/messages/hi.json';
import sw from '@/messages/sw.json';
import tl from '@/messages/tl.json';

export type InterviewMessages = typeof en;

export type InterviewLanguageCode =
  | 'en'
  | 'es'
  | 'fr'
  | 'pt'
  | 'hi'
  | 'sw'
  | 'tl';

const MESSAGES: Record<InterviewLanguageCode, InterviewMessages> = {
  en,
  es,
  fr,
  pt,
  hi,
  sw,
  tl
};

export function resolveLanguageCode(
  config?: InterviewLanguageConfig | null
): InterviewLanguageCode {
  const locale = config?.locale?.toLowerCase() ?? '';
  const base = locale.split('-')[0];
  if (
    base === 'es' ||
    base === 'fr' ||
    base === 'pt' ||
    base === 'hi' ||
    base === 'sw' ||
    base === 'tl'
  ) {
    return base;
  }
  return 'en';
}

export function getInterviewMessages(config?: InterviewLanguageConfig | null): {
  language: InterviewLanguageCode;
  locale: string;
  messages: InterviewMessages;
} {
  const language = resolveLanguageCode(config);
  const locale = config?.locale || 'en-US';
  return { language, locale, messages: MESSAGES[language] };
}
